module.exports = __webpack_public_path__ + "img/newicon3on.36baac93.svg";